<script>
/* eslint no-console: 0 */
import { useVuelidate } from '@vuelidate/core';
import { required, minLength } from '@vuelidate/validators';
import { useAlert } from 'dashboard/composables';
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor.vue';
import WootSubmitButton from '../../../../components/buttons/FormSubmitButton.vue';
import Modal from '../../../../components/Modal.vue';

export default {
  components: {
    WootSubmitButton,
    Modal,
    WootMessageEditor,
  },
  props: {
    id: { type: Number, default: null },
    edDesc: { type: String, default: '' },
    edTitle: { type: String, default: '' },
    onClose: { type: Function, default: () => {} },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      editArticle: {
        showAlert: false,
        showLoading: false,
      },
      title: this.edTitle,
      desc: this.edDesc,
      show: true,
    };
  },
  validations: {
    title: {
      required,
      minLength: minLength(2),
    },
    desc: {
      required,
    },
  },
  computed: {
    pageTitle() {
      return `${this.$t('KB_MGMT.EDIT.TITLE')}`;
    },
  },
  methods: {
    setPageName({ name }) {
      this.v$.desc.$touch();
      this.desc = name;
    },
    resetForm() {
      this.title = '';
      this.desc = '';
      this.v$.title.$reset();
      this.v$.desc.$reset();
    },
    editKnowledgeBaseArticle() {
      // Show loading on button
      this.editArticle.showLoading = true;
      // Make API Calls
      this.$store
        .dispatch('updateKnowledgeBaseArticle', {
          id: this.id,
          title: this.title,
          description: this.desc,
        })
        .then(() => {
          // Reset Form, Show success message
          this.editArticle.showLoading = false;
          useAlert(this.$t('KB_MGMT.EDIT.API.SUCCESS_MESSAGE'));
          this.resetForm();
          setTimeout(() => {
            this.onClose();
          }, 10);
        })
        .catch(error => {
          this.editArticle.showLoading = false;
          const errorMessage =
            error?.message || this.$t('KB_MGMT.EDIT.API.ERROR_MESSAGE');
          useAlert(errorMessage);
        });
    },
  },
};
</script>

<template>
  <Modal v-model:show="show" :on-close="onClose">
    <div class="flex flex-col h-auto overflow-auto">
      <woot-modal-header :header-title="pageTitle" />
      <form
        class="flex flex-col w-full"
        @submit.prevent="editKnowledgeBaseArticle()"
      >
        <div class="w-full">
          <label :class="{ error: v$.title.$error }">
            {{ $t('KB_MGMT.EDIT.FORM.TITLE.LABEL') }}
            <input
              v-model="title"
              type="text"
              :placeholder="$t('KB_MGMT.EDIT.FORM.TITLE.PLACEHOLDER')"
              @input="v$.title.$touch"
            />
          </label>
        </div>

        <div class="w-full">
          <label :class="{ error: v$.desc.$error }">
            {{ $t('KB_MGMT.EDIT.FORM.CONTENT.LABEL') }}
          </label>
          <div class="editor-wrap">
            <WootMessageEditor
              v-model="desc"
              class="message-editor [&>div]:px-1"
              :class="{ editor_warning: v$.desc.$error }"
              enable-variables
              :enable-canned-responses="false"
              :placeholder="$t('KB_MGMT.EDIT.FORM.CONTENT.PLACEHOLDER')"
              @blur="v$.desc.$touch"
            />
          </div>
        </div>
        <div class="flex flex-row justify-end w-full gap-2 px-0 py-2">
          <WootSubmitButton
            :disabled="
              v$.desc.$invalid || v$.title.$invalid || editArticle.showLoading
            "
            :button-text="$t('KB_MGMT.EDIT.FORM.SUBMIT')"
            :loading="editArticle.showLoading"
          />
          <button class="button clear" @click.prevent="onClose">
            {{ $t('KB_MGMT.EDIT.CANCEL_BUTTON_TEXT') }}
          </button>
        </div>
      </form>
    </div>
  </Modal>
</template>

<style scoped lang="scss">
::v-deep {
  .ProseMirror-menubar {
    @apply hidden;
  }

  .ProseMirror-woot-style {
    @apply min-h-[12.5rem];

    p {
      @apply text-base;
    }
  }
}
</style>
